const CustomerData: object = [
  {
    statusTypeBranch: [
      {
        selectValBranch: "",
        selectLabelBranch: "Бүгд"
      },
      {
        selectValBranch: "1",
        selectLabelBranch: "Банк"
      },
      {
        selectValBranch: "2",
        selectLabelBranch: "ББСБ"
      },
      {
        selectValBranch: "3",
        selectLabelBranch: "ХЗХ"
      },
      {
        selectValBranch: "4",
        selectLabelBranch: "Төрийн байгууллага"
      },
      {
        selectValBranch: "5",
        selectLabelBranch: "Үүрэн холбоо"
      },
      {
        selectValBranch: "6",
        selectLabelBranch: "Санхүүгийн түрээс"
      },
      {
        selectValBranch: "7",
        selectLabelBranch: "Даатгалын компани"
      },
      {
        selectValBranch: "8",
        selectLabelBranch: "Үнэт цаасны компани"
      },
      {
        selectValBranch: "9",
        selectLabelBranch: "Бусад"
      }
    ],
    statusType: [
      {
        selectVal: "",
        selectLabel: "Бүгд"
      },
      {
        selectVal: "1",
        selectLabel: "Банк"
      },
      {
        selectVal: "2",
        selectLabel: "ББСБ"
      },
      {
        selectVal: "3",
        selectLabel: "ХЗХ"
      },
      {
        selectVal: "4",
        selectLabel: "Төрийн байгууллага"
      },
      {
        selectVal: "5",
        selectLabel: "Үүрэн холбоо"
      },
      {
        selectVal: "6",
        selectLabel: "Санхүүгийн түрээс"
      },
      {
        selectVal: "7",
        selectLabel: "Даатгалын компани"
      },
      {
        selectVal: "8",
        selectLabel: "Үнэт цаасны компани"
      },
      {
        selectVal: "9",
        selectLabel: "Бусад"
      }
    ],
    statusTypeAddOrg: [
      {
        selectVal: "",
        selectLabel: "Бүгд"
      },
      {
        selectVal: "1",
        selectLabel: "Банк"
      },
      {
        selectVal: "2",
        selectLabel: "ББСБ"
      },
      {
        selectVal: "3",
        selectLabel: "ХЗХ"
      },
      {
        selectVal: "4",
        selectLabel: "Төрийн байгууллага"
      },
      {
        selectVal: "5",
        selectLabel: "Үүрэн холбоо"
      },
      {
        selectVal: "6",
        selectLabel: "Санхүүгийн түрээс"
      },
      {
        selectVal: "7",
        selectLabel: "Даатгалын компани"
      },
      {
        selectVal: "8",
        selectLabel: "Үнэт цаасны компани"
      },
      {
        selectVal: "9",
        selectLabel: "Бусад"
      }
    ],
    orgStatus: [
      {
        selectStatVal: "1",
        selectStatLabel: "Гэрээ хүчинтэй"
      },
      {
        selectStatVal: "2",
        selectStatLabel: "Гэрээ дууссан"
      },
      {
        selectStatVal: "3",
        selectStatLabel: "Гэрээ цуцлагдсан"
      },
      {
        selectStatVal: "4",
        selectStatLabel: "JSON руу шилжсэн"
      }
    ]
  }
];

export default CustomerData;
